/**
 * Areakart store entitlement codes persisted in localStorage as `areakartServiceCodes`.
 * Use these constants everywhere instead of hard-coded strings.
 */
export const AREAKART_SERVICE_CODES = Object.freeze({
  // Navigation / core modules
  DASHBOARD: "DASHBOARD",
  ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
  ORDER_BREAKDOWN: "ORDER_BREAKDOWN",
  CUSTOMER_DATA: "CUSTOMER_DATA",
  CUSTOMER_SUPPORT_DESK: "CUSTOMER_SUPPORT_DESK",
  COUPONS: "COUPONS",
  CASHBACK_COUPONS: "CASHBACK_COUPONS",

  // Delivery assignment (order detail rider tabs)
  ASSIGN_QUICK_RIDERS: "ASSIGN_QUICK_RIDERS",
  ASSIGN_LOGISTIC_DELIVERY: "ASSIGN_LOGISTIC_DELIVERY",

  // Inventory
  // API historically may send BASIC_NVENTORY_MANAGEMENT (missing "I")
  BASIC_INVENTORY_MANAGEMENT: "BASIC_INVENTORY_MANAGEMENT",
  BASIC_NVENTORY_MANAGEMENT: "BASIC_NVENTORY_MANAGEMENT",
  ADVANCED_INVENTORY_MANAGEMENT: "ADVANCED_INVENTORY_MANAGEMENT",

  // Other known plan / addon codes
  ABANDON_CART: "ABANDON_CART",
  CUSTOM_OFFERS: "CUSTOM_OFFERS",
  YOUR_DOMAIN: "YOUR_DOMAIN",
  MARKETING_TOOLS: "MARKETING_TOOLS",
  FORMS_AND_APPOINTMENT: "FORMS_AND_APPOINTMENT",
  WHATSAPP_ALERT: "WHATSAPP_ALERT",
  EMAIL_ALERT: "EMAIL_ALERT",
  AI_ASSISTANT: "AI_ASSISTANT",
  WHATSAPP_BUSINESS_SUITE: "WHATSAPP_BUSINESS_SUITE",
  ONLINE_STORE_BUILDER: "ONLINE_STORE_BUILDER",
  PAYMENT_GATEWAY_PLUS: "PAYMENT_GATEWAY_PLUS",
});

export default AREAKART_SERVICE_CODES;
